// istanbul ignore file
export enum EmailType {
    OCCUPANT_NOTICE = 'OCCUPANT_NOTICE',
    FORWARD_QUOTATION = 'FORWARD_QUOTATION',
    FORWARD_INVOICE = 'FORWARD_INVOICE'
}

export type PreviewEmailResponse = {
    preview_html: string;
    subject?: string;
    from?: {
        email: string;
        name: string;
    };
    recipients?: Array<{
        type: 'to' | 'cc';
        name: string;
        email: string;
        ref?: string;
        value?: string | null;
    }>;
    attachments?: Array<{
        url: string;
        name: string;
    }>;
};

export type DownloadEmailResponse = {
    url: string;
};
